import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { Link } from "react-router-dom";
import GroomingForm from './GroomingFrom';

import petgroomingservice from "../images/pet grooming care_petplazza.jpg";
import Header from '../inc/Header';

function GroomingBook() {
  return (
    <div>
        <Header/>
        <br/>
        <br/>
        <br/>
        <br/>
               <ScrollToTop smooth top="100" color="maroon" />
        <div className="petprescriptionupload">
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Grooming</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

                  <div className="album py-1">

                    <div className="container">
                          <div className="row">
                        <div className="col-md-6 mt-3">
                        <GroomingForm/>
                        </div>
                         <div className="col-md-6 mt-3">
<img src={petgroomingservice} className="d-block w-100" alt="petgroomingservice"/>
                         </div>
                        </div>
                        </div>

                    </div>
                    <br/>
                    <br/>
    </div>
  )
}

export default GroomingBook